import "./reportStyles.scss";

import moment from "moment";
import Popup from "reactjs-popup";
import { GoAlert } from "react-icons/go";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BsCheck2Circle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import { setReport } from "../../../store/slices/methodology.slice";
import avatar from "../../../assets/images/profile/img_placeholder.svg";
import { handleSelectColor, isDevs, timeDisplayFormat } from "../../../utils/utils";

function CardReport({ data, detail = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const customLang = data[0]?.lingoLanguage?.customLang;
  const flag = customLang ? data[0]?.lingoLanguage?.flag.split("-")[1] : data[0]?.lingoLanguage?.flag;

  const handleNavigationDetail = async (item) => {
    await dispatch(setReport(item));
    navigate("/report-details");
  };

  const renderPopup = (value, max) => (
    <Popup
      on={"hover"}
      position={"top center"}
      trigger={<p className="descriptionContent">{value.slice(0, max).concat("...")}</p>}
      style={{ width: 300, zIndex: 999999999, marginLeft: 20 }}
    >
      <div>
        <p>{value}</p>
      </div>
    </Popup>
  );

  const renderCycleAndLevel = (item) => {
    if (item[0]?.contentFile === null && item[0]?.cycleAndLevel.length === 0) return;

    let levelCycle = "";
    let levelStudent = "";

    if (item[0]?.contentFile === null) {
      levelStudent = item[0]?.cycleAndLevel[0]?.level === "DM" ? "C2" : item[0]?.cycleAndLevel[0]?.level;
      levelCycle = item[0]?.cycleAndLevel[0]?.contentCycle ?? 1;
    } else {
      levelStudent = item[item.length - 1]?.contentFile?.level;
      levelCycle = item[item.length - 1]?.contentFile?.cycle ?? 1;
    }

    return (
      <>
        <div className="cycle">
          <label className="labelCycle">{t("CYCLE")}</label>
          <div className={`circle ${handleSelectColor(levelStudent)}`}>
            <span>{levelCycle}</span>
          </div>
        </div>

        <div className={`cycleLevel ${handleSelectColor(levelStudent)}`}>
          <span>{levelStudent === "DEMO" ? "D" : levelStudent}</span>
        </div>
      </>
    );
  };

  return (
    <div className="containerCard">
      <div className="containerRowCard">
        <div className="reportDetailsInfo">
          <p className="reportDateTime">{data[0]?.timetotal?.teacher_timetotal}</p>

          <div className="reportLanguage">
            <FlagIcon size={24} code={flag} />
            <span className="titleLanguage">{data[0]?.lingoLanguage?.description}</span>
            <h4 className="reportLanguageContent">
              {t("CARD_CLASS_CONTENT")}:{" "}
              <span className={data[0]?.classSchedule?.classScheduleDetails[0]?.focus.toLowerCase()}>
                {data[0]?.classSchedule?.classScheduleDetails[0]?.focus}
              </span>
            </h4>

            {data[0]?.checkIfFirstClass && <h4 className="reportLanguageContent"> • {t("FIRST_CLASS")}</h4>}
          </div>
        </div>

        <div className="reportCycleLevelAvatar">
          {renderCycleAndLevel(data)}

          <div className="avatar">
            <img alt="photo avatar" src={data[0]?.student?.user?.picture ?? avatar} />
            <div>
              <span>{t("CARD_CLASS_STUDENT")}</span>
              <p>{decryptIfEncrypted(data[0]?.student?.user?.name)}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="containerRowCard">
        <div className="contentFile">
          {data &&
            data?.map(
              (item, i) =>
                item.contentFile && (
                  <div key={i} className={`reportContent ${detail && "opacity-none"}`}>
                    <a href={item?.contentFile?.linkForTeacher} target="_blank" rel="noreferrer">
                      <div className="buttonCodeContent">
                        <span>{item?.contentFile?.contentCode}</span>
                      </div>
                    </a>

                    <div className="w-150">
                      <label className="titleContent">{t("CLASS_TITLE")}</label>
                      {renderPopup(item?.contentFile?.classTitle, 15)}
                    </div>

                    <div>
                      <label className="titleContent">{t("CYCLE_NAME")}</label>
                      {renderPopup(item?.contentFile?.cycleName, 50)}
                    </div>
                  </div>
                ),
            )}
        </div>

        <div className={`actions ${detail && "opacity-none"}`}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
            {data[0]?.status === "pendent" && (
              <div className="status">
                <GoAlert color="#5E77F3" size={25} />
                <p className="warningText">{t("FILL")}</p>
              </div>
            )}
            {data[0]?.status === "pendent-delayed" && (
              <div className="status">
                <GoAlert color="#FF1600" size={25} />
                <p className="dangerText">{t("RATING_PENDING")}</p>
              </div>
            )}
            {data[0]?.status === "done" && (
              <div className="status">
                <BsCheck2Circle color="#00974D" size={25} />
                <p className="successText">{t("EVALUATED")}</p>
              </div>
            )}
            {data[0]?.status === "done-delayed" && (
              <div className="status">
                <BsCheck2Circle color="#FF1600" size={25} />
                <p className="dangerText">{t("ASSESSED_LATE")}</p>
              </div>
            )}

            {data[0]?.status !== "done" && data[0]?.status !== "done-delayed" && data[0]?.status !== "expired" && (
              <div style={{ display: "flex", gap: 5 }}>
                <p style={{ fontSize: 11 }}>{t("EXPIRES_AT")} </p>
                <span style={{ fontSize: 11 }}>
                  {moment(data[0].deadlineToFill).tz(user.timezone).format(timeDisplayFormat(user?.timeDisplayFormat))}
                </span>
              </div>
            )}
          </div>

          {(data[0]?.status === "pendent" || data[0]?.status === "pendent-delayed") && (
            <button onClick={() => handleNavigationDetail(data)} className="buttonCodeContent pendent">
              <span>{t("FILL")}</span>
            </button>
          )}

          {(data[0]?.status === "done" || data[0]?.status === "done-delayed") && (
            <button onClick={() => handleNavigationDetail(data)} className="buttonCodeContent done">
              <span>{t("CHANGE")}</span>
            </button>
          )}
        </div>
      </div>

      {isDevs && (
        <div className="sequentialScheduleId">
          <p>Sequential ID: {data[0].sequentialScheduleId}</p>
        </div>
      )}
    </div>
  );
}

export default CardReport;
